import React, { useEffect, useState } from "react";
import { Brand, Model } from "@app/store/types";
import { CustomLoader } from "@shared/ui/CustomLoader/CustomLoader";
import { SmallBrandsListProps } from "./types";
import classes from "./SmallBrandsList.module.scss";

const ITEMS_QNT_SHORT_MODE = 15;

const SmallBrandsList = ({
    brands,
    onChanged,
    expandLabel,
    isLoading = false
}: SmallBrandsListProps) => {
    const [isShortMode, setIsShortMode] = useState(true);
    const [shortModePossible, setShortModePossible] = useState(true);
    useEffect(() => {
        if (brands.length <= ITEMS_QNT_SHORT_MODE) {
            setShortModePossible(false);
        } else {
            setShortModePossible(true);
        }
    }, [brands]);

    const toggleMode = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsShortMode(!isShortMode);
    };

    const data = isShortMode ? brands.slice(0, ITEMS_QNT_SHORT_MODE) : brands;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, el: Brand | Model) => {
        e.preventDefault();
        onChanged(el);
    };

    return (
        <div className={classes.smallBrandsList}>
            {isLoading ? (
                <CustomLoader />
            ) : (
                <>
                    <ul className={classes.smallBrandsList__inner}>
                        {data.map((el) => (
                            <li className={classes.smallBrandsList__item} key={el.id}>
                                <a
                                    className={classes.smallBrandsList__link}
                                    onClick={(e) => handleClick(e, el)}
                                    href=""
                                >
                                    <span className={classes.smallBrandsList__item__text}>
                                        {el.name}
                                    </span>
                                </a>
                            </li>
                        ))}
                    </ul>
                    {shortModePossible && (
                        <a
                            onClick={toggleMode}
                            className={classes.smallBrandsList__toggle}
                            href="#"
                        >
                            {isShortMode ? expandLabel : "Показать меньше"}
                        </a>
                    )}
                </>
            )}
        </div>
    );
};

export default SmallBrandsList;